/* eslint-disable max-len */
export default {
    threats: {
        excerpt: {
            title: 'Nie masz pewności, czy Twoje zasoby cyfrowe i aplikacje wymagają wsparcia w zakresie cyberbezpieczeństwa?',
            list: [
                'Dlaczego ryzyko ataku na Twoje dane jest tak duże?',
                'Co dokładnie stracisz w przypadku udanego ataku?',
                'Dlaczego kradzież danych może Cię kosztować aż 4% rocznego obrotu?',
                'Jakie działania i technologie zagwarantują Ci pełne bezpieczeństwo?'
            ],
            button: 'Sprawdź to'
        },
        content: {
            title: 'Czy zasoby Twojej organizacji są bezpieczne?',
            description: 'Liczba ataków na infrastrukturę organizacji i kradzieży danych w ostatnich latach rośnie w zastraszającym tempie.',
            button: 'Zobacz wideo'
        }
    },
    offer: {
        excerpt: {
            title: 'Dlaczego warto wybrać Lemlock jako partnera w kwestii cyberbezpieczeństwa?',
            list: [
                'Dlaczego kompleksowe bezpieczeństwo wymaga interdyscyplinarnego podejścia?',
                'Jakie rozwiązania oferuje lemlock?',
                'Jak ochronić raport przed wyciekiem zawartych w nim informacji?',
                'W jaki sposób udowodnisz, że dobrze zabezpieczasz dane?'
            ],
            button: 'Oferta',
            button_pricing: 'Cennik'
        },
        content: {
            title: 'Zabezpiecz swoje aplikacje i zasoby cyfrowe.',
            description: 'Ochrona zasobów organizacji to wyzwanie, które wymaga wiedzy i działań z obszarów prawnych oraz technologicznych.',
            button: 'Oferta'
        }
    },
    popup: {
        text: 'Podejrzewasz, że Twoja organizacja została zhakowana? Skontaktuj się z nami natychmiast!',
        link: 'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/home.js